import type {CheckoutProfile, CheckoutProfileRuleWrite} from '../types';

export const checkoutProfileExternalFixture: CheckoutProfile = {
  id: '20000000-0000-4000-8000-000000000001',
  name: 'External standard',
  branchId: '10000000-0000-4000-8000-000000000001',
  typeOfSale: 'DEFAULT',
  baseCurrency: 'CZK',
  isActive: true,
  isComplete: true,
  missing: [],
  version: '2026-10-13T08:00:00.000Z',
  saleRegimes: {inEurope: false, outOfEurope: false},
  payments: {
    isMethodChangeAllowed: true,
    defaultMethod: 'BANK_TRANSFER',
    methods: [{method: 'BANK_TRANSFER', isAutoInitiatePayment: false}],
  },
  deposit: {isAllowed: false},
  documentTypes: {correctiveInvoice: false, correctiveTaxDocument: false},
  activeDocumentTypes: ['INVOICE'],
  documents: [
    {
      saleRegime: 'DOMESTIC',
      paymentMethod: 'BANK_TRANSFER',
      documentType: 'INVOICE',
      allowedSeriesIds: ['30000000-0000-4000-8000-000000000001'],
      defaultSeriesId: '30000000-0000-4000-8000-000000000001',
      allowedTemplateIds: ['40000000-0000-4000-8000-000000000001'],
      defaultTemplateId: '40000000-0000-4000-8000-000000000001',
      isOverrideAllowed: true,
    },
  ],
  createdAt: '2026-10-13T08:00:00.000Z',
  createdBy: 'mock-administrator',
  updatedAt: '2026-10-13T08:00:00.000Z',
  updatedBy: 'mock-administrator',
};

export const checkoutProfileInternalFixture: CheckoutProfile = {
  id: '20000000-0000-4000-8000-000000000002',
  name: 'Internal',
  branchId: checkoutProfileExternalFixture.branchId,
  typeOfSale: 'INTERNAL',
  baseCurrency: 'CZK',
  isActive: true,
  isComplete: true,
  missing: [],
  version: checkoutProfileExternalFixture.version,
  documentTypes: {correctiveInvoice: false},
  activeDocumentTypes: ['INVOICE'],
  documents: [
    {...checkoutProfileExternalFixture.documents[0], saleRegime: null, paymentMethod: null},
  ],
  createdAt: checkoutProfileExternalFixture.createdAt,
  createdBy: 'mock-administrator',
  updatedAt: checkoutProfileExternalFixture.updatedAt,
  updatedBy: 'mock-administrator',
};

export const checkoutProfileRuleFixture: CheckoutProfileRuleWrite = {
  name: 'Branch fallback',
  branchId: checkoutProfileExternalFixture.branchId,
  checkoutProfileId: checkoutProfileExternalFixture.id,
  sourceType: 'service-order',
  isActive: false,
  priority: 0,
  conditions: {
    serviceCaseTypeIds: null,
    serviceOrderTypeIds: null,
    serviceOrderVariantIds: null,
    authorizationProfileIds: null,
    directSaleTypeIds: null,
    directSaleVariantIds: null,
  },
};

export type CheckoutProfileMockVariant = {
  id: string;
  name: string;
  branchId: string;
  sourceType: CheckoutProfileRuleWrite['sourceType'];
  isActive: boolean;
  typeId: string;
  typeName: string;
  parentTypeId: string;
  parentTypeName: string;
};

export const checkoutProfileVariantsFixture: CheckoutProfileMockVariant[] = [
  {
    id: '50000000-0000-4000-8000-000000000001',
    name: 'Praha | Mercedes | Commercial',
    branchId: checkoutProfileExternalFixture.branchId,
    sourceType: 'service-order',
    isActive: true,
    typeId: '60000000-0000-4000-8000-000000000001',
    typeName: 'Commercial',
    parentTypeId: '70000000-0000-4000-8000-000000000001',
    parentTypeName: 'Praha | Mercedes',
  },
  {
    id: '50000000-0000-4000-8000-000000000002',
    name: 'Praha | Direct sale',
    branchId: checkoutProfileExternalFixture.branchId,
    sourceType: 'direct-sale',
    isActive: true,
    typeId: '60000000-0000-4000-8000-000000000002',
    typeName: 'Direct sale',
    parentTypeId: '70000000-0000-4000-8000-000000000002',
    parentTypeName: 'Praha authorization',
  },
];

export const checkoutProfilesFixtures = {
  profiles: [checkoutProfileExternalFixture, checkoutProfileInternalFixture],
  variants: checkoutProfileVariantsFixture,
};
